import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core'
import { deepClone } from '@gspwidget/util'
import { WidgetPropertyService } from '@gspwidget/widget-core'
import { PropertyOption, PropertyTypes } from '@gspwidget/widget-devkit'
import { TranslateService } from '@ngx-translate/core'
import { PropertyChangeEvent, PropsAndValues } from '../types'

export interface CEGroupValuePayload {
  group: CEGroup
  allValues: object
}
export interface CEGroup {
  name: string
  children: PropertyOption[]
}
/**
 * CE 内组件引用关系：
 * ce2        ->      ce-item -> ce2 -> ...
 *     -> ce-array ->
 */
@Component({
  selector: 'config-editor2',
  templateUrl: './config-editor2.component.html',
  styleUrls: ['./config-editor2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
  // providers: [ CeService ]
})
export class ConfigEditor2Component implements OnInit {

  @Output() onChange = new EventEmitter<PropertyChangeEvent>()
  @Output() copyGroupValues = new EventEmitter<CEGroupValuePayload>()
  @Output() pasteGroupValues = new EventEmitter<CEGroupValuePayload>()

  propCategories: CEGroup[]
  props: PropertyOption[]
  propValues: object
  /** 是否仅展示用户个性化属性，用于用户个性化设计器，默认关 */
  @Input() userCustomOnly = false
  /** 必填 */
  @Input() set propsAndValues (propsNValues: PropsAndValues) {
    if (!propsNValues) return
    const { props, propValues } = propsNValues
    this.props = processProps(props, this.userCustomOnly)
    // this.propValues = propValuess
    this.propValues = propValues ? deepClone(propValues) : {}
    this.propCategories = buildCategories(this.props)
  }
  @Input() showCategory = true
  @Input() extra: any = {}

  constructor (
    public cd: ChangeDetectorRef
  ) { }

  

  // TODO: 考虑所有的改变都通过 service 传递到这里？
  handleValueChange (prop: PropertyOption, newValue: any) {
    this._changeValue(prop, newValue)
  }
  private _changeValue (prop: PropertyOption, newValue: any) {
    this.propValues[prop.name] = newValue
    this.propValues = deepClone(this.propValues)
    this.onChange.emit({
      propName: prop.name,
      value: newValue
    })
    if (prop.afterChange) prop.afterChange(this.propValues, newValue, this.cd)
  }

  ngOnInit () {
  }

  handleCopyCEGroupPVs (e, group: CEGroup) {
    e.preventDefault()
    e.stopPropagation()
    this.copyGroupValues.emit({
      group,
      allValues: this.propValues
    })
  }
  handlePasteCEGroupPVs (e, group: CEGroup) {
    e.preventDefault()
    e.stopPropagation()
    this.pasteGroupValues.emit({
      group,
      allValues: this.propValues
    })
  }

}

/**
 * 处理原始 props，返回可用的 props。
 * 1. 当前若是 userCustomOnly，则过滤掉所有非 userCustom 属性
 * 2. dynamic 类型推入其注册的 prop；
 */
function processProps (rawProps: PropertyOption[], userCustomOnly = false): PropertyOption[] {
  const props: PropertyOption[] = []
  rawProps.forEach((prop, i) => {
    if (userCustomOnly && !prop.userCustom) return
    if (prop.type === PropertyTypes.Dynamic) {
      let registeredProps
      if (prop.dynamicOption.name) {
        registeredProps = WidgetPropertyService.GetRegisteredProperties(prop.dynamicOption.name)
      } else if (prop.dynamicOption.getOptions) {
        registeredProps = prop.dynamicOption.getOptions()
      }
      if (registeredProps) props.push(...registeredProps)
    } else {
      props.push(prop)
    }
  })
  return props
}

function buildCategories (props: PropertyOption[]) {
  /* 按 category 分类组织 props */
  // if (!showcategory) return
  const propCategories = []
  const otherCategory = { name: 'other', children: [] }
  if (props) props.forEach(prop => {
    // 没写 category 的放到 “其他”
    if (!prop.category) {
      otherCategory.children.push(prop)
    } else {
      // 写了 category 的放到对应的里面
      let category = propCategories.find(c => c.name === prop.category)
      if (!category) {
        category = { name: prop.category, children: [] }
        propCategories.push(category)
      }
      category.children.push(prop)
    }
  })
  // “其他” 排最后
  if (otherCategory.children.length > 0) propCategories.push(otherCategory)
  return propCategories
}
